// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7407a461","268":"c775ed7d","484":"c4af9d3f","508":"943847f0","551":"a83c589b","776":"488659be","842":"50633fd1"}[chunkId] + ".chunk.js";
};